import './bootstrap';
import '../css/app.css';
import '@smastrom/react-rating/style.css';
import '/node_modules/flag-icons/css/flag-icons.min.css';

import { createRoot } from 'react-dom/client';
import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { PostHogProvider } from 'posthog-js/react';
import posthog, { PostHogConfig } from 'posthog-js';
import mapboxgl from 'mapbox-gl';
import * as Sentry from '@sentry/react';

const theme = extendTheme({
    fonts: {
        heading: 'Figtree, sans-serif',
        body: 'Figtree, sans-serif',
    },
});

const postHogConfig: Partial<PostHogConfig> = {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    capture_pageview: false,
    opt_out_capturing_by_default: !import.meta.env.PROD,
};

router.on('navigate', () => {
    posthog.capture('$pageview', { $current_url: window.location.href });
});

mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_API_KEY;

Sentry.init({
    dsn: 'https://fb7713ac27f1f0bdf693ec2f434f6c05@o4511012200316928.ingest.us.sentry.io/4511012252090368',
    sendDefaultPii: true,
    enabled: import.meta.env.PROD,
});

createInertiaApp({
    resolve: name => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_KEY} options={postHogConfig}>
                <ChakraProvider theme={theme}>
                    <App {...props} />
                </ChakraProvider>
            </PostHogProvider>
        );
    },
    progress: {
        color: '#3182CE',
    },
});
